import React from 'react';
import Slide3 from './Slide3';

function Slide3Services() {
  return <Slide3 variant="services" />;
}

export default Slide3Services;
